function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WithdrawalsTemplate = require('./withdrawals.template');
var WithdrawalOverlay = require('./overlays/withdrawal');
var _require = require('./overlays/listing-field-edit'),
  returnStoreWeb3Tickers = _require.returnStoreWeb3Tickers,
  requestStoreWeb3Tickers = _require.requestStoreWeb3Tickers;
var WithdrawalsView = /*#__PURE__*/function () {
  function WithdrawalsView(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, WithdrawalsView);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new WithdrawalOverlay(app, mod);
    // Per-ticker balances. available > 0 shows the withdraw link.
    // pending_on is the timestamp when that pending amount clears one genesis period.
    this.balances = {};
    this.app.connection.on('saito-purchase-cryptos', function () {
      if (!_this.isVisible()) {
        return;
      }
      _this.render(_this.container, {
        requestTickers: false
      });
    });
  }
  return _createClass(WithdrawalsView, [{
    key: "isVisible",
    value: function isVisible() {
      if (!this.container) {
        return false;
      }
      var panel = document.querySelector(this.container);
      return !!(panel !== null && panel !== void 0 && panel.classList.contains('is-active'));
    }
  }, {
    key: "returnRows",
    value: function returnRows() {
      var _this2 = this;
      return returnStoreWeb3Tickers(this.app).filter(function (ticker) {
        return ticker !== 'SAITO';
      }).map(function (ticker) {
        var balance = _this2.balances[ticker] || {};
        return {
          ticker: ticker,
          available: Number(balance.available) || 0,
          pending: Number(balance.pending) || 0,
          pending_on: balance.pending_on || 0
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      if (options.requestTickers !== false) {
        requestStoreWeb3Tickers(this.app);
      }
      this.app.browser.replaceElementContentBySelector(WithdrawalsTemplate({
        rows: this.returnRows()
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "show",
    value: function show() {
      this.render();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-action="withdraw"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var ticker = link.getAttribute('data-ticker') || '';
          var row = _this3.returnRows().find(function (item) {
            return item.ticker === ticker;
          });
          if (!row || !(Number(row.available) > 0)) {
            return;
          }
          _this3.overlay.render({
            ticker: ticker,
            available: String(row.available)
          });
        });
      });
    }
  }]);
}();
module.exports = WithdrawalsView;